// extracted by mini-css-extract-plugin
export default {"table-expand":"table-expand-text_table-expand__qRZ6c"};